var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrendReviewArrhythmiaAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14C23.7614 14 26 16.2386 26 19C26 21.7614 23.7614 24 21 24C18.2386 24 16 21.7614 16 19C16 16.2386 18.2386 14 21 14ZM14.6631 17.5527C14.5572 18.0182 14.5 18.5024 14.5 19C14.5 20.3162 14.8929 21.5399 15.5654 22.5635C14.9466 22.943 14.4074 23.2555 14 23.5C12.0589 22.3354 7.10501 19.6629 4.98633 15.25H9.58105L9.79785 14.875L11.457 11.999L14.6631 17.5527ZM20 20.5V22H22V20.5H20ZM20 16V19.5H22V16H20ZM18.5 5C21.538 5 24 7.5 24 11C24 11.7384 23.915 12.443 23.7627 13.1152C22.9242 12.7209 21.988 12.5 21 12.5C18.5882 12.5 16.4842 13.814 15.3623 15.7646L12.1074 10.125L11.458 9L10.8086 10.125L8.71582 13.75H4.40234C4.14543 12.8905 4 11.9744 4 11C4 7.5 6.5 5 9.5 5C11.36 5 13 6 14 7C15 6 16.64 5 18.5 5Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrendReviewArrhythmiaAlarm);
export default __webpack_public_path__ + "static/media/ic-trendReview-arrhythmia-alarm.9fcc8e30853516a3227293181c68f8c6.svg";
export { ForwardRef as ReactComponent };